<ejs-dialog #modal
			cssClass="modal-lg"
			(close)="closeModal()"
			[attr.data-test-id]="'rapidReviewModal'">
	<ng-template #header>
		<div class="dlg-template">Rapid Review</div>
	</ng-template>
	<ng-template #content>
		<rev-loading-overlay [loading]="isLoading()">
			@if (currentEncounter) {
				<div class="row margin-bottom-md">
					<div class="col-sm-5 col-md-4 col-lg-3">
						<ejs-dropdownlist [dataSource]="encounterDropdownList"
										  [value]="currentEncounter.encounterId"
										  (change)="onEncounterChange($event.itemData)">
						</ejs-dropdownlist>
					</div>
					<div class="col-sm-7 col-md-8 col-lg-9">
						<button type="button" (click)="goToPreviousExam()"
								[disabled]="isFirstExam(currentEncounter.encounterId)"
								class="e-control e-btn e-lib e-icon-btn margin-right-xs"
								[attr.data-test-id]="'previousEncounterHeader'">
							<span class="e-btn-icon fa fa-chevron-left"></span>
						</button>
						@if (isLastExam(currentEncounter.encounterId)) {
							<span class="last-exam-box">LAST EXAM</span>
						} @else {
							<span class="historical-box">HISTORICAL</span>
						}
						<button type="button" (click)="goToNextExam()"
								[disabled]="isLastExam(currentEncounter.encounterId)"
								class="e-control e-btn e-lib e-icon-btn margin-left-xs"
								[attr.data-test-id]="'nextEncounterHeader'">
							<span class="e-btn-icon fa fa-chevron-right"></span>
						</button>
					</div>
				</div>
				@if (displayEncounterNotStartedNotification) {
					<div class="alert alert-warning margin-bottom-md">
						<strong>Notice: The encounter you selected has not started.</strong>
						The data displayed below is from the patient's last exam on
						<strong>{{ formatEncounterName(currentEncounter) }}</strong>
					</div>
				}
				<h4 class="section-title bg-default mrgn-btm d-flex justify-content-between">
					<div>
						<strong class="margin-right-xs">{{ headerResponse.patient | patientName:true }}</strong>
						<small>#{{ headerResponse.patient.patientId }}</small>
					</div>
					<div>
						@for (insurance of headerResponse.insurances; track insurance) {
							<small class="margin-right-md">
								<strong>{{ insurance.name }}</strong> ({{ insurance.priority }} - {{ insurance.type }})
							</small>
						}
					</div>
				</h4>
				@if (showTabs) {
					<ejs-tab
						[animation]="tabAnimation"
						[selectedItem]="tabIndex"
						(selected)="tabIndex = $event.selectedIndex">
						<e-tabitems>
							<e-tabitem>
								<ng-template #headerText>
									<span [attr.data-test-id]="'rapidReviewModalHistoryTab'">History / VAs</span>
								</ng-template>
								<ng-template #content>
									<pms-rapid-review-history [encounterId]="currentEncounter.encounterId"></pms-rapid-review-history>
								</ng-template>
							</e-tabitem>
							<e-tabitem>
								<ng-template #headerText>
									<span [attr.data-test-id]="'rapidReviewModalExamRecapTab'">Exam Recap</span>
								</ng-template>
								<ng-template #content>
									<pms-rapid-review-exam-recap [encounterId]="currentEncounter.encounterId"></pms-rapid-review-exam-recap>
								</ng-template>
							</e-tabitem>
							<e-tabitem>
								<ng-template #headerText>
									<span [attr.data-test-id]="'rapidReviewModalAssessmentAndPlanTab'">Assessment &amp; Plan</span>
								</ng-template>
								<ng-template #content>
									<pms-rapid-review-assessment-and-plan [encounterId]="currentEncounter.encounterId"></pms-rapid-review-assessment-and-plan>
								</ng-template>
							</e-tabitem>
						</e-tabitems>
					</ejs-tab>
				}
			}
		</rev-loading-overlay>
	</ng-template>
	<ng-template #footerTemplate>
		<rev-button
				buttonIcon="close"
				buttonLabel="Close"
				(buttonClick)="closeModal()"
				dataTestId="rapidReviewModalCloseButton">
		</rev-button>
	</ng-template>
</ejs-dialog>
